<template>
  <div class="col-hspace form-classic">
    <div class="col-xs-12 col-vbspace">
      <label for="date">Date de naissance</label>

      <DatePicker
        v-model="info.date"
        :disable-previous-dates="disableDate === 'previous'"
        :disable-future-dates="disableDate === 'future'"
        big
      />
    </div>
    <div class="col-xs-12">
      <label for="hour">Heure de naissance</label>
      <input
        class="classic-input big col-small-vspace col-big-hspace"
        id="hour"
        v-model="info.hour"
        type="time"
        @blur="blurAction"
      />
    </div>
    <div class="col-xs-12">
      <label for="weight">Poids (kg)</label>
      <input
        class="classic-input big col-small-vspace col-big-hspace"
        id="weight"
        v-model="info.weight"
        step="0.001"
        :type="mobile ? 'number' : 'text'"
        @blur="formatWeight"
      />
    </div>
    <div class="col-xs-12">
      <label for="height">Taille (cm)</label>
      <input
        class="classic-input big col-small-vspace col-big-hspace"
        id="height"
        v-model="info.height"
        step="0.1"
        :type="mobile ? 'number' : 'text'"
        @blur="blurAction"
      />
    </div>
  </div>
</template>

<script>
import { DatePicker } from '../../utils';

export default {
  components: { DatePicker },

  props: {
    informations: { type: Object, default: () => {} },
    mobile: { type: Boolean, default: false },
    disableDate: { type: String, default: '' },
  },

  computed: {
    info: {
      get() {
        return this.informations;
      },
      set(val) {
        this.$emit('change-info', val);
      },
    },
  },

  methods: {
    formatWeight(e) {
      this.blurAction(e);

      let newWeight = this.info.weight
        .toString()
        .replace('.', '')
        .replace(',', '')
        .padEnd(4, '0');
      newWeight = [newWeight.slice(0, 1), '.', newWeight.slice(1)].join('');

      this.$set(this.info, 'weight', newWeight);
    },

    blurAction(e) {
      if (e.target.value.length < 1) {
        if (!e.target.classList.contains('error')) {
          e.target.classList.add('error');
        }

        return this.$emit('error');
      }

      e.target.classList.remove('error');
    },
  },
};
</script>
